import Address from '../address/Address';
import { TimeUnitType } from '../global/TimeUnit.enum';
import type { IOrganizationDetails } from './OrganizationDetails.interface';
import OrganizationDetailsCurrency from './OrganizationDetailsCurrency';
import OrganizationDetailsLicenses from './OrganizationDetailsLicenses';

export default class OrganizationDetails implements IOrganizationDetails {
  name: string;
  shorthand: string;
  url: string;
  logo: string;
  logoClient: string;
  location: any;
  abn: string;
  phoneCode: string;
  phone: string;
  address: Address;
  timezone: string;
  currency: OrganizationDetailsCurrency;
  vat: string;
  licenses: OrganizationDetailsLicenses;
  dateFormat: string;
  timeFormat: string;
  timeUnit: TimeUnitType;
  theme: string;

  getName() {
    return this.name;
  }

  getUrl() {
    return this.url;
  }

  getLogo() {
    return this.logo;
  }

  getLogoClient() {
    return this.logoClient;
  }

  getLocation() {
    return this.location?.name?.common || '';
  }

  static build = (data: IOrganizationDetails) => new OrganizationDetails(data);
  static blank = () => new OrganizationDetails();

  /**
   * Constructor
   * @param {IOrganizationDetails} data
   */
  constructor(data?: IOrganizationDetails) {
    this.name = data?.name || undefined;
    this.shorthand = data?.shorthand || undefined;
    this.url = data?.url || undefined;
    this.logo = data?.logo || undefined;
    this.logoClient = data?.logoClient || undefined;
    this.location = data?.location || undefined;
    this.abn = data?.abn || undefined;
    this.phoneCode = data?.phoneCode || undefined;
    this.phone = data?.phone || undefined;
    this.address = new Address(data?.address);
    this.timezone = data?.timezone || undefined;
    this.currency = new OrganizationDetailsCurrency(data?.currency);
    this.vat = data?.vat || undefined;
    this.licenses = new OrganizationDetailsLicenses(data?.licenses);
    this.dateFormat = data?.dateFormat || undefined;
    this.timeFormat = data?.timeFormat || undefined;
    this.timeUnit = TimeUnitType.of(data?.timeUnit);
    this.theme = data?.theme || undefined;
  }
}
